const NAMESPACE = 'Ticket'

// export xlsx worker
export const START_XLSX_EXPORT = NAMESPACE + '/StartXlsxExport'
export const STOP_XLSX_EXPORT = NAMESPACE + '/StopXlsxExport'
export const XLSX_EXPORT_COMPLETED = NAMESPACE + '/XlsxExportCompleted'
export const XLSX_EXPORT_PROGRESSED = NAMESPACE + '/XlsxExportProgressed'
export const XLSX_EXPORT_FAILED = NAMESPACE + '/XlsxExportFailed'
// export pdf worker
export const START_PDF_EXPORT = NAMESPACE + '/StartPdfExport'
export const STOP_PDF_EXPORT = NAMESPACE + '/StopPdfExport'
export const PDF_EXPORT_COMPLETED = NAMESPACE + '/PdfExportCompleted'
export const PDF_EXPORT_PROGRESSED = NAMESPACE + '/PdfExportProgressed'
export const PDF_EXPORT_FAILED = NAMESPACE + '/PdfExportFailed'
// report pdf worker
export const START_PDF_REPORT = NAMESPACE + '/StartPdfReport'
export const STOP_PDF_REPORT = NAMESPACE + '/StopPdfReport'
export const PDF_REPORT_COMPLETED = NAMESPACE + '/PdfReportCompleted'
export const PDF_REPORT_PROGRESSED = NAMESPACE + '/PdfReportProgressed'
export const PDF_REPORT_FAILED = NAMESPACE + '/PdfReportFailed'


// WEBPACK FOOTER //
// ./lib/ticket/protocol.js